import { render, staticRenderFns } from "./PartialTransportationDetail.vue?vue&type=template&id=8f24750c&"
import script from "./PartialTransportationDetail.vue?vue&type=script&lang=js&"
export * from "./PartialTransportationDetail.vue?vue&type=script&lang=js&"
import style0 from "./PartialTransportationDetail.vue?vue&type=style&index=0&id=8f24750c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports